import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { ScreenSizeService, ViewMode } from '../../../../../services/screen-size';
import { CleanupService } from '../../../../../shared/utils/cleanup.service';
import { BildungsangebotTerminDetail } from '../../../../../model';
import { SanitizerService } from '../../../../../services/sanitizer.service';

@Component({
  selector: 'now-wbsuche-lib-weiterbildungsinhalte',
  templateUrl: './weiterbildungsinhalte.component.html',
  styleUrls: ['./weiterbildungsinhalte.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CleanupService],
  imports: []
})
export class WeiterbildungsinhalteComponent {
  private readonly sanitizerService = inject(SanitizerService);

  @Input({ required: true })
  public termin!: BildungsangebotTerminDetail;

  @Input()
  public collapsed?: boolean;

  public isNotMobile$ = inject(ScreenSizeService).rangeFrom$(ViewMode.PHABLET);

  sanitizeFunction(html?: string): string {
    return this.sanitizerService.sanitize(html);
  }
}
